var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 26,
    viewBox: "0 0 20 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.03145 6.64801L9.58818 6.10419L9.03258 6.64909L9.03145 6.64801ZM9.03145 11.4024L9.03258 11.4011L9.58818 11.9459L9.03145 11.4024ZM14.9868 8.01709H17.0429V10.0294H14.9868V8.01709ZM2.86757 15.9708H4.92366V17.9832H2.86757V15.9708ZM15.23 24.8351H16.4202V26H15.23V24.8351ZM3.58013 0H4.77032V1.16482H3.58013V0ZM18.8098 14.0154H20V15.1803H18.8098V14.0154ZM0 10.8197H1.1905V11.9848H0V10.8197ZM4.17517 6.64801C4.17517 8.50471 4.17517 9.54569 4.17517 11.4024H5.97997C6.59914 11.4254 7.21234 11.4969 7.84182 11.6933C8.78664 11.988 9.67554 12.5021 10.4251 13.2358C11.3242 14.116 11.9009 15.1925 12.1547 16.324C11.901 17.4558 11.3242 18.5323 10.4251 19.4123C9.67554 20.1459 8.78662 20.66 7.84182 20.955C6.61271 21.3383 5.44521 21.2459 4.17517 21.2459V26H9.03258C9.03258 24.7573 8.93819 23.6144 9.32987 22.4114C9.63113 21.4866 10.1565 20.6166 10.9061 19.883C12.0838 18.7303 13.6054 18.1196 15.1478 18.0502H15.8251V14.5979H15.1478C13.6054 14.5288 12.0838 13.9178 10.9061 12.765C10.1565 12.0314 9.63113 11.1615 9.32987 10.2367C9.19678 9.82819 9.11994 9.42635 9.07614 9.02523C9.11996 8.62419 9.19678 8.22228 9.32987 7.81381C9.63113 6.88903 10.1565 6.01904 10.9061 5.28545C12.1106 4.10647 13.6749 3.4945 15.253 3.44829H15.8251V5.05481e-05H12.3018V0.560076C12.2553 2.10451 11.6296 3.63594 10.4251 4.81474C9.67557 5.54833 8.78664 6.06246 7.84185 6.35716C7.21237 6.55359 6.59917 6.62507 5.98 6.64806L4.17517 6.64801Z",
    fill: "url(#paint0_linear_522_1340)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_522_1340",
    x1: 0,
    y1: 26,
    x2: 18.2793,
    y2: 26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF791B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.395,
    stopColor: "#BC5B8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D68FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvgLogo);
export default __webpack_public_path__ + "static/media/svg_logo.593e839de28660326fda3c9e3a7946b1.svg";
export { ForwardRef as ReactComponent };